import './styles/boot-loader.css';

export default function BootLoader({ message = 'Preparando Mastermind…' }) {
    return (
        <div className="boot-loader" role="status" aria-live="polite">
            <span className="boot-loader__mark" aria-hidden="true">M</span>
            <p className="boot-loader__message">{message}</p>
        </div>
    );
}
